import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { API_BASE_URL } from "../config/api";
import { getProductsByCategory, trackVisit} from "../api/frontApi";
import "../styles/ProductGallery.css";
import Navbar from "../components/Navbar";
import { useNavigate } from "react-router-dom";
import "../styles/Hero.css";


export default function ProductGallery(categories) {
  const { category } = useParams();
  const [products, setProducts] = useState([]);
  const navigate = useNavigate();


  useEffect(() => {
    const fetchProducts = async () => {
      const data = await getProductsByCategory(category);
      setProducts(data);
    };
    fetchProducts();
  }, [category]);

  const getImageUrl = (product) => {
    const image = product.medias.find((el) => el.isCoverImage);

    return image?.path ? `${API_BASE_URL}/${image.path}` : "";
  };
  const handleProductClick = (product) => {
    trackVisit('product/detail', product.id);
    navigate(`/product/${product.id}`, { state: { product } });
  };

  return (
    <div
      className="gallery-container desktop-layout">
      <div style={{ height: "70px" }}>
        <Navbar category={categories} />
      </div>

      <div className="gallery-grid">
        {products.map((product, index) => (
          <div key={index} className="gallery-item">
            <img
              src={getImageUrl(product)}
              alt={product.name || `T-shirt ${index + 1}`}
              className="gallery-image"
              onClick={() => handleProductClick(product)}
              style={{ cursor: "pointer" }}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
